<template>
  <div class="pr-5">
        <a @click="putItem('1')" 
          id="sharelevel1"
          type="submit" 
          class="commitbutton sharelevel-button"
          :class="{ 'loading': (submitting==1), 'sharelevel-active': (activelevel=='shareLevel1') }"
        >
          <div class="checkbox">
            <i v-if="activelevel=='shareLevel1'" class="checkmark material-icons">check</i>
          </div>
          <div class="boxed">
            {{sharelevel1}}
            <div class="text-xs text-gray-800 font-normal">You will not share anything with this person.</div>
          </div>
        </a>
        <a @click="putItem('2')" 
          type="submit" 
          class="commitbutton sharelevel-button"
          :class="{ 'loading': (submitting==2), 'sharelevel-active': (activelevel=='shareLevel2') }"
        >
          <div class="checkbox">
            <i v-if="activelevel=='shareLevel2'" class="checkmark material-icons">check</i>
          </div>
          <div class="boxed">
            {{sharelevel2}}
            <div class="text-xs text-gray-800 font-normal">This person can view your public profile.</div>
          </div>
        </a>
        <a @click="putItem('3')" 
          type="submit" 
          class="commitbutton sharelevel-button"
          :class="{ 'loading': (submitting==3), 'sharelevel-active': (activelevel=='shareLevel3') }"
        >
          <div class="checkbox">
            <i v-if="activelevel=='shareLevel3'" class="checkmark material-icons">check</i>
          </div>
          <div class="boxed">
            {{sharelevel3}}
            <div class="text-xs text-gray-800 font-normal">This person can view your public profile and review all your chapters.</div>
          </div>
        </a>
        <a @click="putItem('4')" 
          type="submit" 
          class="commitbutton sharelevel-button"
          :class="{ 'loading': (submitting==4), 'sharelevel-active': (activelevel=='shareLevel4') }"
        >
          <div class="checkbox">
            <i v-if="activelevel=='shareLevel4'" class="checkmark material-icons">check</i>
          </div>
          <div class="boxed">
            {{sharelevel4}}
            <div class="text-xs text-gray-800 font-normal">This person can view your public profile, review all your chapters, and your Polish Journal.</div>
          </div>
        </a>
        <a @click="putItem('5')" 
          type="submit" 
          class="commitbutton sharelevel-button"
          :class="{ 'loading': (submitting==5), 'sharelevel-active': (activelevel=='shareLevel5') }"
        >
          <div class="checkbox">
            <i v-if="activelevel=='shareLevel5'" class="checkmark material-icons">check</i>
          </div>
          <div class="boxed">
            {{sharelevel5}}
            <div class="text-xs text-gray-800 font-normal">This person can view everything, including your Polish entries that are set to Private.</div>
          </div>
        </a>
  </div>
</template>

<script>
import axios from 'axios'

  export default {

        props: {
            content: '',
            sharelevel0:'',
            sharelevel1:'',
            sharelevel2:'',
            sharelevel3:'',
            sharelevel4:'',
            sharelevel5:'',
            route:'',
            routeparam:'',
            redirectlink:'',
            buttontarget: {
              default: '_self'
            },
            buttonname: {
              default: 'Confirm',
            },
            buttonicon: {
              default: 'check',
            },
            buttonsize: {
              default: 'text-xs',
            },
            activelevel: '',
        },

        data() {
          return {
            isHidden: true,
            submitting: false,
            errors: [],
            loaded: true,
          }
        },
        
        methods: {

          putItem(thenumber) {
            if (! this.submitting) {
              this.submitting = thenumber;
              this.errors = [];
              axios.put(this.route + thenumber,
                { [this.routeparam]: thenumber }
              )
              .then(() => {
                location.reload();
              })
              .catch((errors) => {
                this.submitting = false;
                this.errors = errors.response?.data?.errors?.[this.routeparam] || [];
              })
            };
          }

        },
      };
</script>
<style>

</style>